<template>
  <ThreeColumn :breadcrumbPaths="paths" wideMainPanel>
    <template v-slot:topLeft>
      <!--return button-->
      <v-btn
        color="white" 
        class="mb-0 black d-print-none"
        :to="{name: 'section', params: $route.params}"
        :disabled="!status_okay"
        :outlined="status_okay"
        active-class="no-active"
      >
        <v-icon small class="mr-4">mdi-arrow-left</v-icon>
        {{ $t('btntxt.back') + $t('labels.legis') }}
      </v-btn>
    </template>

    <template v-slot:title>
      <h1 class="text-h1 mb-3">{{ $t('database.compare_title') }}  </h1>
      <h5 class="titlecapno text-h5 mb-0">{{capnum}} {{long_prov}} </h5>
    </template>

    <template v-slot:leftPanel>
      <!--Legis Info Card-->
      <InfoTable
        :titleText="$t('database.wdg_legis')"
        :tableContent="infoTableContent"
        :contentType="'l_legis'"
      />
    </template>

    <template v-slot:mainPanel>
            
      <template v-if="status_okay">
        <!--alert for differences-->
        <v-alert
          dense text
          type="success"
          class="mb-5"
          icon="mdi-check-circle-outline"
          v-if="left.includes('diff_') || right.includes('diff_')"
        >
          <span>{{$t("database.compare_explanation")}}</span>
        </v-alert>

        <v-alert
          dense text
          type="warning"
          class="mb-5"
          icon="mdi-alert-circle-outline"
          v-else
        >
          <span>{{$t("database.compare_diff")}}</span>
        </v-alert>
      </template>

      <!--alert for error-->
      <v-alert 
        v-else-if="!overlay"
        dense text
        type="error"
        class="mt-3 mb-4"
        icon="mdi-alert-outline"
      > 
        {{$t('error.page_unavailable')}}
      </v-alert>

      <v-row v-if="status_okay" no-gutters class="legis-compare-text">
        <v-col cols="12" sm="6" class="pr-2">
          <v-card :min-height="$vuetify.breakpoint.smAndDown?'':'150'" flat> <!--need another way to match height-->
            <h3 class="text-h3 mb-3 lsidebg pl-1">{{date1}} {{$t('database.version')}}</h3>
            <h5 class="text-h5 mb-3">{{captitle1}}</h5>
            <h5 class="text-h6 mb-3">{{sectitle1}}</h5>
          </v-card>
          
          <v-divider></v-divider>
          <div class="pt-5" v-html="left"></div>
        </v-col>

        <v-col cols="12" sm="6" class="pl-2">
          <v-card  min-height="150" flat>  <!--need another way to match height-->
            <h3 class="text-h3 mb-3 lsidebg pl-1">{{date2}} {{$t('database.version')}}</h3>
            <h5 class="text-h5 mb-3">{{captitle2}}</h5>
            <h5 class="text-h6 mb-3">{{sectitle2}}</h5>
          </v-card>
          
          <v-divider></v-divider>
          <div class= "pt-5" v-html="right"></div>

        </v-col>
      </v-row>

      <!--loading overlay-->
      <v-overlay :value="overlay" class="d-print-none">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </template>
  </ThreeColumn>
</template>

<script>
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  import InfoTable from '../components/InfoTable'
  import DownloadWidget from '../components/DownloadWidget'
  import api from '@/scripts/api'
  import datehelper from '@/scripts/datehelper'
  export default {
    name:'test',
    components:{
      ThreeColumn,
      InfoTable,
      DownloadWidget
    },
    data(){
      return {
        overlay: false,
        status_okay: false,
        num: '',
        prov_num: '',
        left: '',
        right: '',
        captitle1: '',
        captitle2: '',
        sectitle1: '',
        sectitle2: '',
        sec:'',
        date1:'',
        date2:'',
      }
    },
    methods:{
      async compare_cap_sections(){
        this.overlay=true
        var payload= {
          'left': this.$route.query['left'],
          'right': this.$route.query['right'],
          'num': this.$route.query['num']
        }
        try {
          const res = await api.compareCapSection(payload)
          this.left = res['left']
          this.right= res['right']
          this.captitle1 = res['captitle1']
          this.captitle2 = res['captitle2']
          this.sectitle1 = res['sectitle1']
          this.sectitle2 = res['sectitle2']

          this.prov_num = res['prov_num']
          this.date1 = datehelper.format_ver_time(res['date1'])
          this.date2 = datehelper.format_ver_time(res['date2'])
          this.num = this.$route.params.cap
          this.status_okay = true
        } catch {
          this.status_okay = false
        } finally {
          this.overlay = false
        }
      },
    },
    computed:{
      paths(){
        if (this.status_okay){
          var DB_NAMES = {
            en: {
              ord: "Hong Kong Ordinances",
              reg: "Hong Kong Regulations",
              instrument: "Hong Kong Constitutional Instruments",
            },
            tc: {
              ord: "香港條例",
              reg: "香港附屬法例",
              instrument: "香港憲法文件",
            },
            sc: {
              ord: "香港条例",
              reg: "香港附属法例",
              instrument: "香港宪法文件",
            },
          }
          var db_name = DB_NAMES[this.$route.params.lang][this.$route.params.abbr]
          return [
            {text: 'HKLII', disabled: false, href: {name: 'home'}},
            {text: this.$i18n.t('database.dbs'), disabled: false, href: {name: 'databases'}},
            {text: db_name, disabled: false, href: {name: 'legis-db', params: this.$router.params}},
            {text: this.capnum, disabled: false, href: {name: 'sectiontoc', params: this.$router.params}},
            {text: this.long_prov, disabled: false, href: {name: 'section', params: this.$router.params}},
            {text: this.$t('database.compare'), disabled: true}
          ]
        } else {
          return [
            {text: 'HKLII', disabled: false, href: {name: 'home'}},
            {text: this.$i18n.t('database.dbs'), disabled: false, href: {name: 'databases'}},
          ]
        }
      },
      capnum(){
        if (this.num){
          var num = (this.$route.params.abbr=='instrument' ? 'Instrument ' : 'CAP ') + this.num
          return num
        } else {
          return ''
        }
      },
      long_prov(){
        var prov_arr = this.$route.params.num.split('_')
        if (!this.num){
          return ''
        } else if (prov_arr.length === 1){
          return this.prov_num != '' ? this.prov_num : this.$route.params.num
        } else {
          const ProvisionTypes = {
            en: {
              "P": "Part {0}",
              "SD": "Subdivision {0}",
              "D": "Division {0}"
            },
            tc: {
              "P": "第{0}部",
              "SD": "第{0}次分部",
              "D": "第{0}分部",
            },
            sc: {
              "P": "第{0}部",
              "SD": "第{0}次分部",
              "D": "第{0}分部",
            }
          }
          const regex = /(P|SD|D|)(\d+\w*)/
          var conv_prov = prov_arr.map((segment) => {
            var found = segment.match(regex)
            if (found){
                return ProvisionTypes[this.lang][found[1]].replace('{0}', found[2]) || ''
            } else {
                return segment
            }
          })
          return conv_prov.join(' - ')
        }
      },
      infoTableContent(){
        var num_prov = this.capnum ? `${this.capnum} - ${this.long_prov}` : ''
        return [
          {name: this.$t('database.cap'), value: num_prov},
          {name: this.$t('database.version') + ' 1', value: this.date1},
          {name: this.$t('database.version') + ' 2', value: this.date2},
        ]
      },
      /*windowTitle(){
        return `${this.capnum} ${this.long_prov} ${this.$t('database.compare')} | HKLII`
      }*/
    },
    /*watch:{
      windowTitle: function(){
        window.document.title = this.windowTitle
      }
    },*/
    mounted(){
      this.compare_cap_sections()
    },
    metaInfo(){
      return{
        title: this.$t('database.compare'),
      }
    },
  }
</script>

<style>
  /*highlights the differences*/
  .diff_insert{
    background-color: #bdffbd;
  }
  .diff_delete{
    margin-top: -1px;
    text-decoration: none;
    background-color: #ffd6d6;
  }
</style>

<style lang="scss" scoped>
  @import '@/sass/_typography.scss';
  
  .legis-compare-text ::v-deep a {
    @include link-no-underline-block-hover;
  }

  .titlecapno{
    /*background-color: var(--v-footergrey-base);*/
    color: var(--v-footergrey-darken2);
    font-size: 12pt !important;
    font-weight: 700;
    display: inline-block;
    vertical-align: top;
      @media print{
       vertical-align: baseline;
       font-size:11pt;
     }
  }

  .v-btn--active.no-active:not(:focus):not(:hover)::before{
    opacity: 0 !important; /*keep nav button color*/
  }
  
  @import '@/sass/_legis.scss';
</style>

